/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceUnitStatementEntryDebit } from './BalanceUnitStatementEntryDebit';
import {
    BalanceUnitStatementEntryDebitFromJSON,
    BalanceUnitStatementEntryDebitFromJSONTyped,
    BalanceUnitStatementEntryDebitToJSON,
    BalanceUnitStatementEntryDebitToJSONTyped,
} from './BalanceUnitStatementEntryDebit';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface GetLocationResponse
 */
export interface GetLocationResponse {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof GetLocationResponse
     */
    locationId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {string}
     * @memberof GetLocationResponse
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof GetLocationResponse
     */
    email: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLocationResponse
     */
    city: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLocationResponse
     */
    zipCode: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLocationResponse
     */
    addressLine1: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLocationResponse
     */
    addressLine2: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLocationResponse
     */
    addressLine3: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLocationResponse
     */
    phoneNumber: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLocationResponse
     */
    timeZone: string | null;
    /**
     * 
     * @type {BalanceUnitStatementEntryDebit}
     * @memberof GetLocationResponse
     */
    taxRate: BalanceUnitStatementEntryDebit | null;
    /**
     * 
     * @type {string}
     * @memberof GetLocationResponse
     */
    description: string | null;
    /**
     * 
     * @type {string}
     * @memberof GetLocationResponse
     */
    externalTerminalId: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof GetLocationResponse
     */
    isActive: boolean;
    /**
     * 
     * @type {string}
     * @memberof GetLocationResponse
     */
    externalAchTerminalId: string | null;
}

/**
 * Check if a given object implements the GetLocationResponse interface.
 */
export function instanceOfGetLocationResponse(value: object): value is GetLocationResponse {
    if (!('locationId' in value) || value['locationId'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('city' in value) || value['city'] === undefined) return false;
    if (!('zipCode' in value) || value['zipCode'] === undefined) return false;
    if (!('addressLine1' in value) || value['addressLine1'] === undefined) return false;
    if (!('addressLine2' in value) || value['addressLine2'] === undefined) return false;
    if (!('addressLine3' in value) || value['addressLine3'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('timeZone' in value) || value['timeZone'] === undefined) return false;
    if (!('taxRate' in value) || value['taxRate'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('externalTerminalId' in value) || value['externalTerminalId'] === undefined) return false;
    if (!('isActive' in value) || value['isActive'] === undefined) return false;
    if (!('externalAchTerminalId' in value) || value['externalAchTerminalId'] === undefined) return false;
    return true;
}

export function GetLocationResponseFromJSON(json: any): GetLocationResponse {
    return GetLocationResponseFromJSONTyped(json, false);
}

export function GetLocationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLocationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'locationId': ApiUserTasksGetPageParameterFromJSON(json['locationId']),
        'name': json['name'],
        'email': json['email'],
        'city': json['city'],
        'zipCode': json['zipCode'],
        'addressLine1': json['addressLine1'],
        'addressLine2': json['addressLine2'],
        'addressLine3': json['addressLine3'],
        'phoneNumber': json['phoneNumber'],
        'timeZone': json['timeZone'],
        'taxRate': BalanceUnitStatementEntryDebitFromJSON(json['taxRate']),
        'description': json['description'],
        'externalTerminalId': json['externalTerminalId'],
        'isActive': json['isActive'],
        'externalAchTerminalId': json['externalAchTerminalId'],
    };
}

export function GetLocationResponseToJSON(json: any): GetLocationResponse {
    return GetLocationResponseToJSONTyped(json, false);
}

export function GetLocationResponseToJSONTyped(value?: GetLocationResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'locationId': ApiUserTasksGetPageParameterToJSON(value['locationId']),
        'name': value['name'],
        'email': value['email'],
        'city': value['city'],
        'zipCode': value['zipCode'],
        'addressLine1': value['addressLine1'],
        'addressLine2': value['addressLine2'],
        'addressLine3': value['addressLine3'],
        'phoneNumber': value['phoneNumber'],
        'timeZone': value['timeZone'],
        'taxRate': BalanceUnitStatementEntryDebitToJSON(value['taxRate']),
        'description': value['description'],
        'externalTerminalId': value['externalTerminalId'],
        'isActive': value['isActive'],
        'externalAchTerminalId': value['externalAchTerminalId'],
    };
}

